import { compose } from 'lodash/fp';
import { ApplicationEntryEnhancer } from '../../../../entrypoint';
import { createTrackingSettingsMappingStrategy } from './mapping';

export function createTrackingSettingAssetStrategy(): ApplicationEntryEnhancer {
    return compose(createTrackingSettingsMappingStrategy());
}
